import { ReactComponent as HelpSvg } from '../../../../assets/icons/Help.svg';

import { createIconComponent } from './createIconComponent';

export const HelpIcon = createIconComponent(HelpSvg);
